
(function () {
  'use strict';

  var RANG = { REQUIRED: 3, RECOMMENDED: 2, OPTIONAL: 1 };
  var merker = {};
  var gewichte = {};

  function abruf(url) {
    if (window.EngineStatus) return window.EngineStatus.hol(url);
    return fetch(url).then(function (r) { return r.json(); });
  }

  function monitorGewicht(proxy, refs) {
    var offen = (refs || []).map(function (ref) {
      var k = String(ref);
      if (gewichte[k] != null) return Promise.resolve(gewichte[k]);
      return abruf(proxy + '/monitors/' + encodeURIComponent(k))
        .then(function (json) {
          var g = (json && json.ok && json.data && json.data.weight_g) || 0;
          gewichte[k] = Number(g) || 0;
          return gewichte[k];
        })
        .catch(function () { return 0; });
    });
    return Promise.all(offen).then(function (liste) {
      var summe = 0;
      liste.forEach(function (g) { summe += g; });
      return summe / 1000;
    });
  }

  function pruefe(opts) {
    opts = opts || {};
    var qs = [];
    if (opts.art) qs.push('table_material=' + encodeURIComponent(opts.art));
    if (opts.kg) qs.push('setup_total_weight_kg=' + encodeURIComponent(Number(opts.kg).toFixed(2)));
    if (opts.mountSku) qs.push('mount_sku=' + encodeURIComponent(opts.mountSku));
    if (opts.plateSku) qs.push('vesa_plate_sku=' + encodeURIComponent(opts.plateSku));
    if (!qs.length) return Promise.resolve(null);

    var url = (opts.proxy || '/apps/monitor-db') + '/funnel/recommendations?' + qs.join('&');
    if (merker[url]) return merker[url];

    merker[url] = abruf(url).then(function (json) {
      var recs = (json && json.ok && json.data && json.data.recommendations) || [];
      var raus = { TABLE_REINFORCEMENT: null, PLATE: null };
      recs.forEach(function (rec) {
        var p = (rec.products || [])[0];
        if (!p || !(p.type in raus)) return;
        var alt = raus[p.type];
        if (alt && (RANG[alt.stufe] || 0) >= (RANG[rec.requirement] || 0)) return;
        raus[p.type] = { stufe: rec.requirement, text: rec.message || '',
                         sku: p.shopify_sku || p.sku, handle: p.handle,
                         name: p.name, bild: p.image_url, imShop: p.in_shop !== false };
      });
      return raus;
    }).catch(function () { return { TABLE_REINFORCEMENT: null, PLATE: null }; });

    return merker[url];
  }

  window.Verstaerkung = { pruefe: pruefe, monitorGewicht: monitorGewicht };
})();
